import { memo } from 'react';

import { CommandGroup, CommandItem } from '@src/design-system/command';
import { DropdownMenuItem } from '@src/design-system/dropdown-menu';

import type { TLocale } from '@shared/types/locale';

export const SelectContentCountry = memo(
  ({
    onSelect,
    isSelected,
    countries = [],
  }: {
    onSelect?: (country: TLocale) => void;
    isSelected?: (country: TLocale) => boolean;
    countries?: TLocale[];
  }) => {
    return (
      <CommandGroup>
        {countries?.map((country) => (
          <CommandItem
            key={country.code}
            value={country.name}
            isSelected={isSelected?.(country)}
            onSelect={() => onSelect?.(country)}
            className='p-0'
          >
            <DropdownMenuItem className='size-full focus:bg-transparent'>
              <span>{country.flag_emoji}</span>
              {country.name}
            </DropdownMenuItem>
          </CommandItem>
        ))}
      </CommandGroup>
    );
  }
);
